module.exports = __webpack_public_path__ + "static/media/400124_01.ca662c82.png";